import { PeriodMode } from '../../../../enums/periodMode'

export const DEFAULT_PERIOD_MODE = PeriodMode.Month
